module.exports = {"511622100":"沿口镇","511622101":"中心镇","511622102":"烈面镇","511622103":"飞龙镇","511622104":"乐善镇","511622105":"万善镇","511622106":"龙女镇","511622107":"三溪镇","511622108":"赛马镇","511622109":"胜利镇","511622110":"金牛镇","511622111":"清平镇","511622112":"街子镇","511622113":"万隆镇","511622114":"礼安镇","511622115":"华封镇","511622116":"宝箴塞镇","511622117":"石盘镇","511622118":"鸣钟镇","511622201":"真静乡","511622202":"猛山乡","511622203":"双星乡","511622208":"鼓匠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511622.json
// module id = 2500
// module chunks = 0